export default {
  section: {
    general: 'General',
    data: 'Data',
    limits: 'Limits',
  },
};
